export type StripeConfig = {
    publishableKey: string;
    paymentMethodConfigurationId: string;
};

const PROD_STRIPE_CONFIGURATION_BY_CURRENCY: Record<string, StripeConfig> = {
    AUD: {
        publishableKey:
            'pk_live_51PNdJHPEztQSV80vMD768GH4fw4cIoey4bjpVR8uvCFC0IesD5YmT4npUSM0RqhFCwYA0hlpaetYpp5a0eTTh56W00cJJE4l1d',
        paymentMethodConfigurationId: 'pmc_1Qquo5PEztQSV80v8TSkVgdv',
    },
};

const TEST_STRIPE_CONFIGURATION_BY_CURRENCY: Record<string, StripeConfig> = {
    AUD: {
        publishableKey:
            'pk_test_51PNdJHPEztQSV80vy1qdVg96OU2LqwLiM8oe1VAFvKK1dpChYmm04Us75vdDuTq0P0ED1n4ECrMskuyNpSkpxDr900TJvjMo6p',
        paymentMethodConfigurationId: 'pmc_1QnHZoPEztQSV80v0t9CUofy',
    },
};

const TEST_STRIPE_CONFIGURATION: StripeConfig = {
    publishableKey:
        'pk_test_51Pd79RFyGVs0gTWz3qjYu4IKNriFmMpb6WJvx8jR0AQnfTuIT8vJy7MRsXFZ4zgMlq2JVkPwAZ7B3uxcCmtd9klP00VFpMRfgp',
    paymentMethodConfigurationId: 'pmc_1PdRdBFyGVs0gTWzHQXyZAVd',
};

export const getStripeConfiguration = (
    currency: string,
    isProd: boolean,
): StripeConfig | undefined => {
    if (!isProd) {
        return (
            TEST_STRIPE_CONFIGURATION_BY_CURRENCY[currency] ??
            TEST_STRIPE_CONFIGURATION
        );
    }

    return PROD_STRIPE_CONFIGURATION_BY_CURRENCY[currency];
};

export const isThereStripeConfiguration = (
    currency: string,
    isProd: boolean,
): boolean => {
    return !!getStripeConfiguration(currency, isProd);
};

export const convertFullAmountToCentAmount = (
    amount: number,
    currencyPrecision: number,
) => {
    // amount in dollars (euros, baths, whatever) multiplied by precision where precision = number of symbols after the point
    return Math.round(amount * Math.pow(10, currencyPrecision));
};
